// Generated by ts-to-zod
import { z } from 'zod';

export const schemaListQuerySchema = z.object({
  id: z.number().optional(),
  name: z.string().optional(),
});
